import React, { FC, useEffect, useContext, useState } from "react";
import { Route, Switch } from "react-router";
import { animateScroll } from "react-scroll";
import AOS from 'aos';

import { LangContext } from "../../providers/LangProvider";

import Produtos from "../../pages/3R-Produtos";

import { MainDiv } from "./styles";
import 'aos/dist/aos.css';

// main
const Main: FC<any> = () => {
  const { lang } = useContext(LangContext);
  
  const [ animate, setAnimate ] = useState<boolean | any>(null);

  // use effect
  useEffect(() => {
    animateScroll.scrollTo(0);
    setAnimate(true);
    AOS.init({ duration : 1000 });

    setTimeout(() => setAnimate(false), 2000);
  }, []);

  // render
  return (
    <MainDiv>
      <Switch>
        <Route path={'/'} exact><Produtos lang={lang} animate={animate} /></Route>
      </Switch>
    </MainDiv>
  );
};

export default Main;